import { render, staticRenderFns } from "./ModalGeneralCommentsPQs.vue?vue&type=template&id=738c1aa4"
import script from "./ModalGeneralCommentsPQs.vue?vue&type=script&lang=js"
export * from "./ModalGeneralCommentsPQs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports